import { render, staticRenderFns } from "./RefCodeFormattingHelpComponent.vue?vue&type=template&id=270cbac4&scoped=true"
import script from "./RefCodeFormattingHelpComponent.vue?vue&type=script&lang=js"
export * from "./RefCodeFormattingHelpComponent.vue?vue&type=script&lang=js"
import style0 from "./RefCodeFormattingHelpComponent.vue?vue&type=style&index=0&id=270cbac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cbac4",
  null
  
)

export default component.exports